import React, { useContext, useEffect } from 'react';
import {
  generatePath,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

// Components
import InteractiveButton from '../../../components/InteractiveButton/InteractiveButton';
import ROUTE from '../../../constants/route-constants';
import { PAGE_TITLE } from '../../../constants/common';
import { connect } from 'react-redux';
import { Dispatch, RootState } from '../../../store/store';
import { AbilityContext } from '../../../components/Can/Can';
import { Action } from '../../../enums/action';
import useSafeRequest from '../../../hooks/useSafeRequest';

type ComponentProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

type Tab = { title: string; path: string };

const LIST_TABS: Tab[] = [
  { title: PAGE_TITLE.EDIT_CONTROLLER, path: ROUTE.EDIT_CONTROLLER },
  { title: PAGE_TITLE.CONTROLLER_CHANNELS, path: ROUTE.CONTROLLER_CHANNELS },
  { title: PAGE_TITLE.CONTROLLER_CHANNEL_FAULTS, path: ROUTE.CONTROLLER_CHANNEL_FAULTS },
  { title: PAGE_TITLE.CONTROLLER_CHANNELS_NAMES, path: ROUTE.CONTROLLER_CHANNELS_NAMES },
  { title: PAGE_TITLE.CONTROLLER_CHANNELS_COLORS, path: ROUTE.CONTROLLER_CHANNELS_COLORS },
  { title: PAGE_TITLE.EDIT_CONTROLLER_SETTINGS, path: ROUTE.EDIT_CONTROLLER_SETTINGS },
  { title: PAGE_TITLE.EDIT_CONTROLLER_SYSTEM_FAULTS, path: ROUTE.EDIT_CONTROLLER_SYSTEM_FAULTS },
  { title: PAGE_TITLE.EDIT_CONTROLLER_FAULT_CONTROL, path: ROUTE.EDIT_CONTROLLER_FAULT_CONTROL },
  { title: PAGE_TITLE.CALIBRATION_CERTIFICATES, path: ROUTE.CALIBRATION_CERTIFICATES },
  { title: PAGE_TITLE.EDIT_CONTROLLER_POWER_SHARE, path: ROUTE.EDIT_CONTROLLER_POWER_SHARE },
  { title: PAGE_TITLE.CONTROLLER_CONSOLE_SETUP, path: ROUTE.CONTROLLER_CONSOLE_SETUP },
];

const EditControllerOutlet: React.FC<ComponentProps> = ({ user, getControllerById, resetState, getCurrentUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const currentLoc = generatePath(location.pathname, { id: id });
  const ability = useContext(AbilityContext);

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  const availableList = LIST_TABS.filter((tab) => {
    if (tab.title === PAGE_TITLE.EDIT_CONTROLLER_POWER_SHARE && !user?.organization?.isTecheat) {
      return false;
    }
    return ability.can(Action.Read, tab.title);
  });

  useSafeRequest({
    request: getControllerById,
    params: { id },
    options: { deps: [location], reset: resetState },
  });

  return (
    <div className="c-edit-controller-outlet flex gap-y-2 flex-col">
      <div className="flex items-center gap-x-2 overflow-x-auto">
        {availableList.map((item) => {
          return (
            <InteractiveButton
              key={item.title}
              text={item.title}
              onClick={() =>
                navigate(generatePath(item.path, { id }))
              }
              className='h-full text-nowrap min-w-fit'
              customType={`bg-primary font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700] ${currentLoc.includes(
                generatePath(item.path, { id })
              )
                ? 'bg-primary text-white'
                : 'bg-white text-black'
              }`}
            />
          );
        })}
      </div>
      <Outlet />
    </div>
  );
};

const mapState = (state: RootState) => ({
  user: state.user.profile,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getControllerById: dispatch.controllers.getController,
  resetState: dispatch.controllers.resetOne,
  getCurrentUser: dispatch.user.getCurrentUser,
});

export default connect(mapState, mapDispatch)(EditControllerOutlet);
